module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v("Getting started")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subheading text-muted"
  }, [_vm._v("Watch videos from your friends in 6 easy steps !")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_c('li', [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": require("../../assets/img/about/step-1-thumbnail.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 1")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Get your ID")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Open the app and click on \"Copy\" in the upper right corner.")])])])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": require("../../assets/img/about/step-2-thumbnail.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 2")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Share your ID")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Share the ID you just copied with a friend who want to watch your videos.")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": require("../../assets/img/about/step-3-thumbnail.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 3")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Connect")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Enter your friend's ID in the \"Remote\" tab.")])])])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": require("../../assets/img/about/step-4-thumbnail.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 4")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Choose your video")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Choose a video from your friend's collection in the \"Collections\" panel.")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-image"
  }, [_c('img', {
    staticClass: "rounded-circle img-fluid",
    attrs: {
      "src": require("../../assets/img/about/step-5-thumbnail.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }, [_c('h4', [_vm._v("Step 5")]), _vm._v(" "), _c('h4', {
    staticClass: "subheading"
  }, [_vm._v("Wait a short time")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Your friend is automatically preparing the video for you before streaming it.")])])])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-image"
  }, [_c('h4', [_vm._v("Step 6"), _c('br'), _vm._v("Enjoy"), _c('br'), _vm._v("Your video")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318efa9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/About.vue
// module id = 112
// module chunks = 1